import { type IUploadingFile } from '../models';

export const getFullUploadProgress = (files: IUploadingFile[]): number => {
  if (!files.length) return 0;

  const sum = files
    .map(file => {
      const uploadProgress = file.progress?.percentage || 0;
      if (uploadProgress < 100) return uploadProgress;
      // S3 upload done, but backend must also confirm storage
      return file.stored ? 100 : 99;
    })
    .reduce((total, progress) => total + progress, 0);

  return sum / files.length;
};
